import "core-js/modules/es.array.push.js";
import Swiper from 'swiper';
export default {
  name: 'collection',
  meta: {
    title: '藏品公开库'
  },
  data() {
    return {
      logoimg: '',
      ydsearch: true,
      props: {
        children: 'children',
        label: 'title'
      },
      Keyword: '',
      typeData: [],
      List: [],
      totalPage: 0,
      total: 0,
      listImgFlag: true,
      hasImg: 'checked',
      hasImgflag: true,
      currentTypeArr: [],
      checkedkeys: [],
      params: {
        page: 1,
        limit: 10,
        showImageflag: true,
        antiqueTypes: '',
        antiqueName: ''
      },
      currentPage: 1,
      detail: '',
      ldflag: true,
      antiquetitle: '',
      ydmenu: false,
      singleform: {
        limit: 12,
        page: 1
      },
      // hasSearch: false,
      checkedTree: [],
      searchStr: '',
      eraData: [],
      checkedEra: [],
      contentHeight: '',
      showIndex: 0,
      themeColor: '',
      isLoading: true,
      themes: {
        '黄色': 'yellow',
        '红色': 'red',
        '蓝色': 'blue',
        '绿色': 'green'
      },
      // 改变列表页选择时候的样式
      activeColors: {
        '黄色': '#caa452',
        '红色': 'rgb(140,45,45)',
        '蓝色': 'rgb(88,130,154)',
        '绿色': 'rgb(134,153,123)'
      },
      bgColor: '',
      title: '藏品公开库',
      logoImg: '',
      totalNum: 0,
      totalInfo: {
        page: 1,
        totalPage: 1
      },
      lock: false,
      treeNodes: [],
      eraNodes: [],
      theme: {},
      bigImg: ''
    };
  },
  methods: {
    // 放大图片
    swipertop(img) {
      console.log(img);
      this.bigImg = img;
    },
    // 滚动事件
    scrollEvent(e) {
      if (e.srcElement.scrollTop + e.srcElement.clientHeight >= e.srcElement.scrollHeight - 100) {
        if (this.isLoading) return;
        if (this.totalPage == this.currentPage) return;
        this.currentPage = this.currentPage + 1;
        this.getDetailByCode();
      }
    },
    ydshowmenu() {
      this.ydmenu = true;
    },
    ydshowsearch() {
      this.ydsearch = true;
    },
    ydhidesearch() {
      this.ydsearch = false;
    },
    shadefun() {
      this.ydmenu = false;
    },
    /* 是否有图切换 */
    hasImghandle() {
      this.hasImgflag = !this.hasImgflag;
      // this.params.page = 1
      this.currentPage = 1;
      this.getList();
    },
    /* 搜索 */
    topSearch() {
      this.params.antiqueName = this.Keyword;
      this.checkedTree = [];
      this.$refs.tree.setCheckedKeys([]);
      this.ldflag = true;
      // this.params.page = 1
      this.currentPage = 1;
      // this.hasSearch = this.Keyword ? true : false
      this.searchStr = this.Keyword ? {
        filters: [[{
          alias: "antiqueName",
          compt: "editinput",
          express: 'like',
          id: 5,
          range: null,
          val: this.Keyword
        }]],
        model: 0
      } : '';
      this.getDetailByCode();
      // this.defaultData()
    },
    toIndex() {
      this.checkedTree = [];
      this.$refs.tree.setCheckedKeys([]);
      this.currentPage = 1;
      this.searchStr = '';
      this.getDetailByCode();
    },
    getDetailByCode() {
      let formData = {
        deptId: this.$route.query.fid || '151066',
        formId: 90852,
        limit: 30,
        page: this.currentPage,
        searchStr: ''
      };
      // 是否公开
      let a = {
        filters: [[{
          alias: "127",
          compt: "selectbox",
          express: "match",
          // id: 34,
          range: null,
          val: ['是']
        }]],
        model: 0
      };
      if (this.currentPage == 1) {
        this.totalInfo = {
          page: 1,
          totalPage: 0
        };
        this.totalNum = 0;
        if (this.lock) {
          setTimeout(() => {
            this.lock = false;
            this.getTotalNum();
          }, 800);
        } else {
          this.getTotalNum();
        }
      }
      let searchStr = JSON.parse(JSON.stringify(this.searchStr));
      searchStr ? searchStr.filters.push(a.filters[0]) : '';
      formData.searchStr = searchStr ? encodeURI(JSON.stringify(searchStr)) : encodeURI(JSON.stringify(a));
      this.isLoading = true;
      this.$api.singleadvanceSearch(formData).then(res => {
        this.totalPage = res.totalPage;
        this.total = res.totalRow;
        this.setData(res.dataList);
        this.isLoading = false;
      });
    },
    // 获取总值
    getTotalNum() {
      let formData = {
        deptId: this.$route.query.fid || '151066',
        formId: 90852,
        limit: 100,
        page: this.totalInfo.page,
        searchStr: ''
      };
      // 是否公开
      let a = {
        filters: [[{
          alias: "127",
          compt: "selectbox",
          express: "match",
          // id: 34,
          range: null,
          val: ['是']
        }]],
        model: 0
      };
      let searchStr = JSON.parse(JSON.stringify(this.searchStr));
      searchStr ? searchStr.filters.push(a.filters[0]) : '';
      formData.searchStr = searchStr ? encodeURI(JSON.stringify(searchStr)) : encodeURI(JSON.stringify(a));
      this.$api.singleadvanceSearch(formData).then(res => {
        if (this.lock) return;
        if (this.totalInfo.page == 1) {
          this.totalInfo.totalPage = res.totalPage;
          this.totalNum = 0;
        }
        if (res.totalPage != this.totalInfo.totalPage) return;
        if (this.totalInfo.totalPage > this.totalInfo.page) {
          if (this.totalInfo.page == 1 && this.totalNum) return;
          this.totalInfo.page += 1;
          this.getTotalNum();
        }
        res.dataList.map((item, index) => {
          this.totalNum += item.formIdValueData.realCount.groupValues[0].values[0] ? item.formIdValueData.realCount.groupValues[0].values[0][0].realNumVal : 0;
        });
        // console.log(this.totalNum)
      });
    },
    removetype(val, type) {
      let nodes = type ? this.$refs.tree2.getNode(this.checkedEra[val]) : this.$refs.tree.getNode(this.checkedTree[val]);
      let parents = `${nodes.data.title}/`;
      this.getParents(nodes, type ? 2 : 1, parents, false);
      // type == era 删除年代标签
      type ? this.checkedEra.splice(val, 1) : this.checkedTree.splice(val, 1);
      let checkData = type ? this.checkedEra.map(c => {
        return c.title;
      }) : this.checkedTree.map(c => {
        return c.title;
      });
      type ? this.$refs.tree2.setCheckedKeys(checkData) : this.$refs.tree.setCheckedKeys(checkData);
      this.setCheckedParams();
    },
    removeAll() {
      this.checkedTree = [];
      this.checkedEra = [];
      this.treeNodes = [];
      this.eraNodes = [];
      this.$refs.tree.setCheckedKeys([]);
      this.$refs.tree2.setCheckedKeys([]);
      this.setCheckedParams();
    },
    /* 展示列表 */
    golist() {
      this.ldflag = true;
    },
    /* 分类选择 */
    handleCheckChange(data, treedata) {
      let nodes = this.$refs.tree.getNode(data);
      this.checkedTree = treedata.checkedNodes.length ? treedata.checkedNodes : [];
      let parents = `${nodes.data.title}/`;
      // this.getParents(nodes, 1, parents, nodes.checked)
      this.getChildren(nodes, 1, parents, nodes.checked);
      this.setCheckedParams();
    },
    // 年代选择
    checkChangeEra(data, treedata) {
      this.checkedEra = treedata.checkedNodes.length ? treedata.checkedNodes : [];
      let nodes = this.$refs.tree2.getNode(data);
      if (nodes.checked) {
        let parents = `${nodes.data.title}/`;
        // this.getParents(nodes, 2, parents, nodes.checked)
        // 年代可以全选，根据年代进行分类查询
        this.getChildren(nodes, 2, parents, nodes.checked);
      } else {
        let index = this.eraNodes.findIndex(item => {
          return item.indexOf(nodes.data.title) > -1;
        });
        index > -1 ? this.eraNodes.splice(index, 1) : '';
      }
      this.setCheckedParams();
    },
    getParents(nodes, type, parents, checked) {
      if (nodes.level != 0) {
        nodes.level != 1 ? parents += `${nodes.parent.data.title}/` : '';
        if (nodes.level == 1) {
          parents = parents.split('/').reverse().join('/').slice(1);
          if (!checked) {
            let index = type == 1 ? this.treeNodes.findIndex(item => {
              return item == parents;
            }) : this.eraNodes.findIndex(item => {
              return item == parents;
            });
            type == 1 ? this.treeNodes.splice(index, 1) : this.eraNodes.splice(index, 1);
          } else {
            type == 1 ? this.treeNodes.push(parents) : this.eraNodes.push(parents);
          }
          console.log(this.treeNodes);
        }
        this.getParents(nodes.parent, type, parents, checked);
      }
    },
    getChildren(nodes, type, parents, checked) {
      parents = `${nodes.data.title}/`;
      this.getParents(nodes, type, parents, checked);
      if (nodes.childNodes.length) {
        nodes.childNodes.map(child => {
          this.getChildren(child, type, parents, checked);
        });
      }
    },
    setCheckedParams() {
      this.searchStr = this.checkedTree.length || this.checkedEra.length ? {
        filters: [],
        model: 0
      } : '';
      this.lock = true;
      // console.log(this.checkedEra, this.checkedTree)
      if (this.checkedTree.length) {
        let filter = [{
          alias: "antiqueType",
          compt: "multipleselect",
          express: 'match',
          id: 65,
          range: null,
          val: this.treeNodes
        }];
        this.searchStr.filters.push(filter);
        console.log(this.searchStr, 111);
      }
      if (this.checkedEra.length) {
        let filter = [{
          alias: "era",
          compt: "multipleselect",
          express: 'match',
          id: 54,
          range: null,
          val: this.eraNodes
        }];
        this.searchStr.filters.push(filter);
        console.log(this.searchStr, 222);
      }
      this.defaultData();
    },
    /* 默认参数 */
    defaultData(a) {
      this.currentPage = 1;
      this.getDetailByCode();
    },
    /* 分页获取数据 */
    handleCurrentChange(val) {
      this.currentPage = val;
      // this.singleform.page = val
      this.getDetailByCode();
    },
    getList() {
      this.singleform.fid = this.$route.query.fid || '151066';
      this.singleform.formId = this.$route.query.formId;
      this.$api.singleformList(this.singleform).then(res => {
        this.total = res.total;
        this.setData(res.data);
      });
    },
    getStruct() {
      let params = {
        deptId: this.$route.query.fid || '151066',
        formId: 90852
      };
      this.$api.formStruct(params).then(res => {
        let target = res.find(d => {
          return d.alias == 'antiqueType';
        });
        target = target ? target.field.multiOptions : [];
        let eraData = res.find(d => {
          return d.alias == 'era';
        });
        eraData = eraData ? eraData.field.multiOptions : [];
        this.eraData = eraData;
        this.typeData = target;
      });
      let params2 = {
        deptId: this.$route.query.fid || '151066',
        formId: 329432
      };
      this.$api.formStruct(params2).then(res => {});
    },
    setData(data) {
      let list = data.map(item => {
        let target = {
          primaryImage: this.getFormData(item, 'primaryImage', 'fileUrl'),
          antiqueName: this.getFormData(item, 'antiqueName', 'val'),
          antiqueCode: this.getFormData(item, 'antiqueCode', 'val'),
          era: this.getFormData(item, 'era', 'val'),
          antiqueTypename: this.getFormData(item, 'antiqueType', 'val'),
          texturea: this.getFormData(item, 'texture', 'val'),
          detailSize: this.getFormData(item, 'detailSize', 'val'),
          incompleteLevel: this.getFormData(item, 'incompleteLevel', 'val'),
          remark: this.getFormData(item, 'remark', 'val'),
          aidedImage: this.getFormData(item, 'aidedImage', 'imgs'),
          otherImage: this.getFormData(item, 'otherImage', 'imgs')
        };
        return target;
      });
      this.currentPage == 1 ? this.List = list : this.List = this.List.concat(list);
    },
    getFormData(data, Tkey, key) {
      data = data.formIdValueData;
      if (!data[Tkey] || !data[Tkey].groupValues) return key == 'imgs' ? [] : '';
      let target = data[Tkey].groupValues[0];
      if (!target) return key == 'imgs' ? [] : '';
      if (key == 'imgs') {
        let values = target.values[0];
        return values.map(t => {
          return t ? `https://museum.chaoxing.com/star3/origin/${t.objectId}.${t.suffix}` : '';
        });
      }
      if (key == 'fileUrl') {
        let values = target.values[0];
        if (!values[0]) return '';
        return `https://museum.chaoxing.com/star3/origin/${values[0].objectId}.${values[0].suffix}`;
      }
      return target.values.length && target.values[0] ? target.values[0][0] ? target.values[0][0][key] : '' : '';
    },
    /* 切换列表图片展示方式 */
    changeType(val) {
      this.listImgFlag = val;
    },
    /* 根据当前节点 获取父节点 */
    findAncestry(arr, dictCode) {
      let temp = [];
      const List = arr;
      function forFn(list, id) {
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          if (item.dictCode == id) {
            temp.push(item);
            if (item.parentCode !== 0) {
              forFn(List, item.parentCode);
            }
            break;
          } else {
            if (item.children !== undefined) {
              forFn(item.children, id);
            }
          }
        }
      }
      forFn(arr, dictCode);
      return temp;
    },
    /* 获取详情 */
    godetail(val) {
      this.detail = val;
      let banner = [];
      this.detail.primaryImage ? banner = [this.detail.primaryImage] : '';
      this.detail.bannerArr = banner.concat(this.detail.aidedImage).concat(this.detail.otherImage);
      this.ldflag = false;
      this.$nextTick(() => {
        if (document.body.clientWidth > 768) {
          var galleryThumbs = new Swiper('.smallbox .gallery-thumbs', {
            spaceBetween: 20,
            slidesPerView: 3,
            navigation: {
              nextEl: '.smallbox .swiper-button-next',
              prevEl: '.smallbox .swiper-button-prev'
            },
            direction: 'vertical',
            observer: true,
            observerParents: true
          });
        }
        var galleryTop = new Swiper('.gallery-top', {
          spaceBetween: 20,
          thumbs: {
            swiper: galleryThumbs
          },
          pagination: {
            el: '.gallery-top .swiper-pagination',
            clickable: true
          },
          autoplay: {
            delay: 5000,
            disableOnInteraction: true
          },
          observer: true,
          observerParents: true
        });
      });
    },
    getThemeColor() {
      let formData = {
        deptId: this.$route.query.fid || '151066',
        formId: 329432,
        limit: 10,
        page: 1,
        searchStr: ''
      };
      this.$api.singleadvanceSearch(formData).then(res => {
        if (!res.dataList || !res.dataList.length) {
          this.themeColor = 'yellow';
          this.title = '藏品公开库';
          this.bgColor = '#caa452';
          this.theme = {
            styleType: 1,
            needYear: 1
          };
          return;
        }
        let color = this.getFormData(res.dataList[0], 'color', 'val') || '黄色';
        this.title = this.getFormData(res.dataList[0], 'logoName', 'val') || '藏品公开库';
        this.logoImg = this.getFormData(res.dataList[0], 'logoImg', 'fileUrl') || '';
        let styleType = this.getFormData(res.dataList[0], 'styleType', 'val');
        let needYear = this.getFormData(res.dataList[0], 'needYear', 'val');
        this.theme = {
          styleType: styleType ? styleType.indexOf('统一') > -1 ? 2 : 1 : 1,
          needYear: needYear ? needYear == '是' ? 1 : 0 : 1
        };
        this.themeColor = this.themes[color];
        this.bgColor = this.activeColors[color];
      }).catch(msg => {
        this.themeColor = 'yellow';
        this.title = '藏品公开库';
      });
    }
  },
  created() {
    this.getStruct();
    this.getDetailByCode();
    this.getThemeColor();
    if (document.body.clientWidth < 1081) {
      this.ydsearch = false;
    }
  },
  computed: {}
};